import { LBLabel, LBRadioGroup, LBRadioGroupItem } from '@linearb/buzz';
import Text, { Inline } from 'components/base/Text';

export const RadioboxGroup = ({
  title = null,
  description,
  value,
  setValue,
  isRequired = false,
  disabled = false,
  options = [] // should be an array of objects and each object contains 'name' and 'value' keys
}) => {
  return (
    <div className='mt-4 flex flex-col'>
      {title && (
        <div className='mb-2'>
          <Text textTransform='uppercase' mb='small' size='medium'>
            {isRequired && (
              <Inline size='medium' color='radicalRed'>
                *{' '}
              </Inline>
            )}
            {title}
          </Text>
        </div>
      )}
      <Text size='medium' lineHeight='2rem' width='90%' color='shuttleGray'>
        {description}
      </Text>
      <LBRadioGroup onValueChange={value => setValue(value)} value={value}>
        <div className='mt-4 flex flex-row gap-4'>
          {options.map(option => (
            <div className='flex items-center gap-2' key={option.value}>
              <LBRadioGroupItem
                key={option.value}
                id={option.value}
                value={option.value}
                disabled={disabled}
              />
              <LBLabel htmlFor={option.value}>{option.name}</LBLabel>
            </div>
          ))}
        </div>
      </LBRadioGroup>
    </div>
  );
};
